module.exports = __webpack_public_path__ + "ad17f8e19923a42fb5a4dd0d796aa57d.svg";